"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Boxplot;
var _react = _interopRequireWildcard(require("react"));
var _chartsReact = require("@carbon/charts-react");
var _util = require("./util");
var _useResizeObserver = require("../../../common/Hooks/useResizeObserver");
var _useBreakPoint = require("../../../common/useBreakPoint");
var _util2 = require("../Barchart/util");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-boxplot-container .cds--cc--axes g.axis.bottom g.tick text {\n  font-family: 'Helvetica Neue LT Roman';\n  font-size: 12px;\n  color: #000000; }\n\n.sia-boxplot-container .cds--cc--axes g.axis.left g.tick text {\n  font-family: 'Helvetica Neue LT Roman';\n  font-size: 16px;\n  color: #000000; }\n\n.sia-boxplot-container .cds--cc--chart-wrapper .stroke-1-1-1 {\n  stroke: var(--sia-bp-stroke);\n  fill: var(--sia-bp-fill); }\n\n.sia-boxplot-container .cds--cc--chart-wrapper .stroke-1-1-1.hovered {\n  stroke: var(--sia-bp-stroke);\n  fill: var(--sia-bp-fill); }\n\n.sia-boxplot-container .ticks .tick text {\n  transform-box: fill-box; }\n\n.sia-boxplot-container .median .stroke-1-1-1 {\n  stroke-width: 3; }\n\n.sia-boxplot-container .whisker.start.stroke-1-1-1,\n.sia-boxplot-container .whisker.end.stroke-1-1-1 {\n  stroke-width: 2; }\n\n@media (max-width: 671px) {\n  .sia-boxplot-container {\n    max-width: 100%;\n    width: 100%; }\n  .sia-boxplot-container div.cds--cc--legend {\n    margin-left: 0 !important; }\n  .sia-boxplot-container .cds--cc--axes g.axis.bottom g.tick text {\n    font-size: 14px; } }\n";
  const fileName = "Boxplot_Boxplot";
  const element = document.querySelector("style[data-sass-component='Boxplot_Boxplot']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Boxplot(_ref) {
  let {
    data,
    options,
    ownValues,
    bandWidth
  } = _ref;
  const {
    isMobile,
    width
  } = (0, _useBreakPoint.useBreakPoint)();
  let mergedOptions = (0, _util.getOptions)(options, isMobile, width);
  let {
    fill,
    stroke,
    ownValueStroke,
    ownValueStrokeWidth,
    ...rest
  } = mergedOptions;
  const ref = (0, _react.useRef)(null);
  const [chartRef, setCharRef] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (ref.current) {
      let chartRef = ref.current.chartRef.current;
      setCharRef(chartRef);
    }
  }, [bandWidth]);
  (0, _useResizeObserver.useResizeObserver)(chartRef, () => {
    (0, _util.renderOwnPathes)(ref, chartRef, ownValues, ownValueStroke, ownValueStrokeWidth);
  });
  (0, _react.useEffect)(() => {
    if (chartRef) {
      (0, _util.renderOwnPathes)(ref, chartRef, ownValues, ownValueStroke, ownValueStrokeWidth);
      let renderCompleteListener = () => {
        if (isMobile) {
          (0, _util2.rotateBottomTicks)(chartRef);
        }
      };
      let events = ref.current.chart.services.events;
      events.addEventListener('axis-render-complete', renderCompleteListener);
      return () => events.removeEventListener('axis-render-complete', renderCompleteListener);
    }
  }, [chartRef, ownValues, ownValueStroke, ownValueStrokeWidth, isMobile]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-boxplot-container sia-padding-02-left sia-padding-03-right",
    style: {
      '--sia-bp-stroke': stroke,
      '--sia-bp-fill': fill
    }
  }, /*#__PURE__*/_react.default.createElement(_chartsReact.BoxplotChart, {
    ref: ref,
    data: data,
    options: {
      ...rest,
      height: (0, _util2.getComputedHeight)(chartRef, bandWidth, data, 5)
    }
  }));
}
Boxplot.prototype = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    group: _propTypes.default.string,
    order: _propTypes.default.number,
    value: _propTypes.default.num
  })),
  ownValues: _propTypes.default.arrayOf(_propTypes.default.number),
  options: _propTypes.default.objectOf(_propTypes.default.any),
  bandWidth: _propTypes.default.number
};